import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

const PasswordConfirmationPop = ({ closecustomPost, callUpdateProfile, showPassPop, loaderBtn, updateProfileLoader }) => {

    const [passwordErrMsg, setPasswordErrMsg] = useState('');
    const [updatePassword, setUpdatePassword] = useState('');
    const [showPass, setShowPass] = useState(false);

    const handleSubmit = (e) => {
        if (updatePassword.length > 0) {
            setPasswordErrMsg(''); 
            updateProfileLoader(true); 
            callUpdateProfile(updatePassword);
        } else setPasswordErrMsg("This field is required")
    }

    const showPassEvent = event => {
        setShowPass(!showPass);
        var x = document.getElementById("AccountPassword");

        var element = document.getElementById("show_password_icon");
        element.classList.toggle("view_pass");

        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    const closePop =()=>{
        setPasswordErrMsg('');
        setUpdatePassword('');
        setShowPass(false);
        closecustomPost();
    }

    return <Modal 
        dialogClassName=" modal-dialog-centered modal-overflow personalizePopupModal dynamic-popup"
        show={showPassPop}
        onHide={closePop}
        centered
    >

        <Modal.Header className="modal-header justify-content-end personalize_wt" closeButton>
        </Modal.Header>


        <Modal.Body>

            <div className="row">
                <div className="col-lg-12">
                    <div className="upgredeMain text-center mb-5">
                        <div className="passHead">
                            <h2>Confirm Password</h2>
                        </div>
                        <p className="text-center"><strong>Please Enter Your Current Password.</strong></p>
                        <div className="spacer10px"></div>
                        
                        <div className="updatePassword text-start">
                            <div className="form-group">
                                <label htmlFor="ProfilePassword"><strong>Current Password</strong></label>
                                <div className="input password position-relative"><input name="password" className={`form-control placeholder-no-fix ${passwordErrMsg.length > 0 ? "border-danger" : ""}`} type={showPass ? "text" : "password"} id="AccountPassword" autoComplete={'new-password'} onChange={(e) => setUpdatePassword(e.target.value)} /> <button id="show_password_icon" type="button" className="show_password_icon" onClick={()=> showPassEvent() } data-factors-form-bind="true" data-factors-click-bind="true">
                                            <FontAwesomeIcon type={'regular'} icon={'eye'} iconClass={'text-gray-500'} />
                                            <FontAwesomeIcon type={'regular'} icon={'eye-slash'} iconClass={'text-gray-500'} />
                                        </button></div>
                                {passwordErrMsg.length > 0 && <span id="profileemailIderror" className="errorMessage required">{passwordErrMsg}</span>}
                            </div>
                            <div className="form-group">
                                <a
                                    id="addonFeaturesScroll"
                                    onClick={(e) => handleSubmit(e)}
                                    className={`w-100 commanBtn btn btn-primary px-5 d-inline-block btn btn-primary${loaderBtn ? ' spinner spinner-right' : ''}`}
                                >
                                    Update Now
                                </a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </Modal.Body>
    </Modal>
}

export default PasswordConfirmationPop;